import React, { useState } from "react";
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import axios from "axios";
import baseUrl from "../../baseUrl";
import Spinner from "../../Components/Spinner/Spinner";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { parseJwt } from "../../utils/parseJwt";
import "./WriteBlog.css";

const WriteBlog = () => {
  const token = JSON.parse(localStorage.getItem("WM:user-token"));

  const [title, setTitle] = useState("");
  const [image, setImage] = useState("");
  const [previewImage, setPreviewImage] = useState("");
  const [category, setCategory] = useState("");
  const [loading, setLoading] = useState(false);
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  const navigate = useNavigate();

  const handlePublish = (e) => {
    e.preventDefault();
    const rawContentState = convertToRaw(editorState.getCurrentContent());
    const content = draftToHtml(rawContentState);

    if (!title || !image || !category || !content) {
      toast.error("Please fill all fields.");
    } else {
      const userId = parseJwt(token).id;

      const formData = new FormData();
      formData.append("userId", userId);
      formData.append("title", title);
      formData.append("image", image);
      formData.append("category", category);
      formData.append("content", content);

      setLoading(true);
      axios
        .post(`${baseUrl}/blog/create-blog`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          if (response.data.success === true) {
            toast.success(response.data.message);
            navigate("/");
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => setLoading(false));
    }
  };

  const handleEditorChange = (state) => {
    setEditorState(state);
  };

  return (
    <>
      {loading && <Spinner />}
      <div className="flex items-center justify-center p-12">
        <div className="mx-auto w-full max-w-[550px]">
          <h1 className="text-3xl pb-3">Create New Blog</h1>
          <form onSubmit={handlePublish}>
            <div className="mb-5">
              <label
                htmlFor="name"
                className="mb-3 block text-base font-medium text-[#07074D]"
              >
                Title
              </label>
              <input
                type="text"
                name="title"
                id="title"
                placeholder="Blog Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium  outline-none focus:border-[#6A64F1] focus:shadow-md"
              />
            </div>
            <div className="mb-5">
              <label
                className="mb-3 block text-base font-medium text-[#07074D]"
                htmlFor="image"
              >
                Image
              </label>
              <input
                className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium  outline-none focus:border-[#6A64F1] focus:shadow-md"
                id="image"
                type="file"
                name="image"
                required
                onChange={(e) => {
                  setImage(e.target.files[0]);
                  setPreviewImage(URL.createObjectURL(e.target.files[0]));
                }}
                accept="image/*"
              />
              {image && (
                <img src={previewImage} alt="upload-blog" className="h-28" />
              )}
            </div>
            <div className="mb-5">
              <label
                htmlFor="countries"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                Select a Category
              </label>
              <select
                onChange={(e) => setCategory(e.target.value)}
                value={category}
                id="category"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
              >
                <option name="category" value="">
                  Choose a Category
                </option>
                <option name="category" value="Technology">
                  Technology
                </option>
                <option name="category" value="Gadgets">
                  Gadgets
                </option>
                <option name="category" value="Finance">
                  Finance
                </option>
                <option name="category" value="Programming">
                  Programming
                </option>
                <option name="category" value="Interviews">
                  Interviews
                </option>
                <option name="category" value="Infographics">
                  Infographics
                </option>
                <option name="category" value="Personal Stories">
                  Personal Stories
                </option>
                <option name="category" value="Case Studies">
                  Case Studies
                </option>
                <option name="category" value="Agricultures">
                  Agricultures
                </option>
                <option name="category" value="Science">
                  Science
                </option>
                <option name="category" value="Arts">
                  Arts
                </option>
                <option name="category" value="Politics">
                  Politics
                </option>
                <option name="category" value="Movies">
                  Movies
                </option>
                <option name="category" value="Photography">
                  Photography
                </option>
                <option name="category" value="Others">
                  Others
                </option>
              </select>
            </div>
            <div className="mb-5">
              <label
                htmlFor="message"
                className="mb-3 block text-base font-medium text-[#07074D]"
              >
                Content
              </label>

              <Editor
                stripPastedStyles={true}
                editorState={editorState}
                wrapperClassName="wrapper mb-3"
                editorClassName="editor"
                onEditorStateChange={handleEditorChange}
              />
            </div>
            <div>
              <button className="hover:shadow-form rounded-md bg-[#6A64F1] py-3 px-8 text-base font-semibold text-white outline-none">
                {loading ? "Publishing..." : "Publish"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default WriteBlog;
